export default __webpack_public_path__ + "static/media/step1-1.0e212117.png";